module.exports = __webpack_public_path__ + "img/5.4b76ff92.png";